module.exports = __webpack_public_path__ + "img/external.0e84eac7.svg";